import { createBlock as a, openBlock as n, resolveDynamicComponent as s, normalizeClass as o, withCtx as u, renderSlot as c, createElementVNode as B, computed as l, unref as d, createElementBlock as p, createCommentVNode as v, createVNode as S } from "vue";
import { _ as m } from "./DIcon.js";
import { _ as x } from "./DLoader.js";
const k = {
  __name: "Base",
  props: {
    tag: String,
    hover: Boolean,
    active: Boolean,
    disabled: Boolean
  },
  setup(e) {
    return (t, r) => (n(), a(s(e.tag), {
      class: o(["button-base-surface-default hover:button-base-surface-hover active:button-base-surface-active button-base-on-surface-neutral-default hover:button-base-on-surface-neutral-hover active:button-base-on-surface-neutral-active shadow-xs ring-1 ring-inset ring-(--button-base-border-default) hover:ring-(--button-base-border-hover) active:ring-(--button-base-border-active)", {
        "button-base-surface-hover! button-base-on-surface-neutral-hover! ring-(--button-base-border-hover)!": e.hover,
        "button-base-surface-active! button-base-on-surface-neutral-active! ring-(--button-base-border-active)!": e.active
      }]),
      disabled: e.disabled,
      active: e.active
    }, {
      default: u(() => [
        c(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["disabled", "active", "class"]));
  }
}, w = {
  __name: "Destructive",
  props: {
    tag: String,
    hover: Boolean,
    active: Boolean,
    disabled: Boolean
  },
  setup(e) {
    return (t, r) => (n(), a(s(e.tag), {
      class: o(["button-destructive-primary-surface-default hover:button-destructive-primary-surface-hover active:button-destructive-primary-surface-active button-destructive-primary-on-surface-default hover:button-destructive-primary-on-surface-hover active:button-destructive-primary-on-surface-active shadow-xs focus-visible:outline-(--border-destructive-base)!", {
        "button-destructive-primary-surface-hover! button-destructive-primary-on-surface-hover!": e.hover,
        "button-destructive-primary-surface-active! button-destructive-primary-on-surface-active!": e.active,
        "button-base-surface-disabled! button-base-on-surface-neutral-default!": e.disabled
      }]),
      disabled: e.disabled,
      active: e.active
    }, {
      default: u(() => [
        c(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["disabled", "active", "class"]));
  }
}, z = {
  __name: "DestructiveSubtle",
  props: {
    tag: String,
    hover: Boolean,
    active: Boolean,
    disabled: Boolean
  },
  setup(e) {
    return (t, r) => (n(), a(s(e.tag), {
      class: o(["button-destructive-subtle-surface-default hover:button-destructive-subtle-surface-hover active:button-destructive-subtle-surface-active button-destructive-subtle-on-surface-default hover:button-destructive-subtle-on-surface-hover active:button-destructive-subtle-on-surface-active shadow-xs focus-visible:outline-(--border-destructive-base)! ring-1 ring-inset ring-(--button-destructive-subtle-border-default) hover:ring-(--button-destructive-subtle-border-hover) active:ring-(--button-destructive-subtle-border-active)", {
        "button-destructive-subtle-surface-hover! button-destructive-subtle-on-surface-hover! ring-(--button-destructive-subtle-border-hover)!": e.hover,
        "button-destructive-subtle-surface-active! button-destructive-subtle-on-surface-active! ring-(--button-destructive-subtle-border-active)!": e.active,
        "ring-transparent! button-base-surface-disabled! button-base-on-surface-neutral-default!": e.disabled
      }]),
      disabled: e.disabled,
      active: e.active
    }, {
      default: u(() => [
        c(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["disabled", "active", "class"]));
  }
}, $ = {
  __name: "InputAlias",
  props: {
    tag: String,
    active: Boolean,
    focused: Boolean,
    disabled: Boolean
  },
  setup(e) {
    return (t, r) => (n(), a(s(e.tag), {
      class: o(["surface-input-default text-neutral-base ring-1 ring-inset ring-(--border-neutral-base) hover:ring-(--border-neutral-strong)", {
        "ring-2 ring-(--border-focus)!": e.focused || e.active,
        "opacity-50": e.disabled
      }]),
      "d-group-border": ""
    }, {
      default: u(() => [
        c(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}, I = {
  __name: "Outline",
  props: {
    tag: String,
    hover: Boolean,
    active: Boolean,
    disabled: Boolean
  },
  setup(e) {
    return (t, r) => (n(), a(s(e.tag), {
      class: o(["ring-1 ring-inset ring-(--button-outline-border-default) hover:ring-(--button-outline-border-hover) active:ring-(--button-outline-border-active) button-outline-surface-default hover:button-outline-surface-hover active:button-outline-surface-active button-outline-on-surface-default hover:button-outline-on-surface-hover active:button-outline-on-surface-active hover:overlay-subtle active:overlay-base shadow-xs active:outline active:outline-offset-2 active:outline-(--button-outline-border-default)", {
        "button-outline-surface-hover! button-outline-on-surface-hover! ring-(--button-outline-border-hover)! overlay-subtle!": e.hover,
        "button-outline-surface-active! button-outline-on-surface-active! ring-(--button-outline-border-active)! overlay-base! outline! outline-offset-2! outline-(--button-outline-border-default)!": e.active,
        "ring-(--button-base-border-default)! button-base-on-surface-neutral-default!": e.disabled
      }]),
      disabled: e.disabled,
      active: e.active
    }, {
      default: u(() => [
        c(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["disabled", "active", "class"]));
  }
}, C = {
  __name: "Brand",
  props: {
    tag: String,
    hover: Boolean,
    active: Boolean,
    disabled: Boolean
  },
  setup(e) {
    return (t, r) => (n(), a(s(e.tag), {
      class: o(["button-brand-primary-surface-default hover:button-brand-primary-surface-hover active:button-brand-primary-surface-active button-brand-primary-on-surface-default hover:button-brand-primary-on-surface-hover active:button-brand-primary-on-surface-active shadow-xs", {
        "button-brand-primary-surface-hover! button-brand-primary-on-surface-hover!": e.hover,
        "button-brand-primary-surface-active! button-brand-primary-on-surface-active!": e.active,
        "button-base-surface-disabled! button-base-on-surface-neutral-default!": e.disabled
      }]),
      disabled: e.disabled,
      active: e.active
    }, {
      default: u(() => [
        c(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["disabled", "active", "class"]));
  }
}, T = {
  __name: "BrandSubtle",
  props: {
    tag: String,
    hover: Boolean,
    active: Boolean,
    disabled: Boolean
  },
  setup(e) {
    return (t, r) => (n(), a(s(e.tag), {
      class: o(["button-brand-subtle-surface-default hover:button-brand-subtle-surface-hover active:button-brand-subtle-surface-active button-brand-subtle-on-surface-default hover:button-brand-subtle-on-surface-hover active:button-brand-subtle-on-surface-active shadow-xs ring-1 ring-inset ring-(--button-brand-subtle-border-default) hover:ring-(--button-brand-subtle-border-hover) active:ring-(--button-brand-subtle-border-active)", {
        "button-brand-subtle-surface-hover! button-brand-subtle-on-surface-hover! ring-(--button-brand-subtle-border-hover)!": e.hover,
        "button-brand-subtle-surface-active! button-brand-subtle-on-surface-active! ring-(--button-brand-subtle-border-active)!": e.active
      }]),
      disabled: e.disabled,
      active: e.active
    }, {
      default: u(() => [
        c(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["disabled", "active", "class"]));
  }
}, D = { class: "flex items-center text-superadmin" }, U = {
  __name: "Superadmin",
  props: {
    tag: String,
    hover: Boolean,
    active: Boolean,
    disabled: Boolean,
    border: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    return (t, r) => (n(), a(s(e.tag), {
      class: o(["hover:button-transparent-surface-hover active:button-transparent-surface-active button-base-on-surface-neutral-default hover:button-base-on-surface-neutral-hover active:button-base-on-surface-neutral-active", {
        "button-transparent-surface-hover! button-base-on-surface-neutral-hover!": e.hover,
        "is-active button-transparent-surface-active! button-base-on-surface-neutral-active!": e.active,
        "shadow-xs button-superadmin": e.border
      }]),
      disabled: e.disabled,
      active: e.active
    }, {
      default: u(() => [
        B("span", D, [
          c(t.$slots, "default")
        ])
      ]),
      _: 3
    }, 8, ["class", "disabled", "active"]));
  }
}, N = {
  __name: "TextLink",
  props: {
    tag: String,
    hover: Boolean,
    active: Boolean,
    disabled: Boolean,
    linkColor: String,
    linkUnderline: Boolean,
    linkSize: String
  },
  setup(e) {
    const t = e, r = l(() => {
      switch (t.linkColor) {
        case "base":
          return "button-base-on-surface-neutral-default hover:button-base-on-surface-neutral-hover active:button-base-on-surface-neutral-active";
        case "superadmin":
          return "text-superadmin";
        case "destructive":
          return "button-transparent-on-surface-destructive-default hover:button-transparent-on-surface-destructive-hover active:button-transparent-on-surface-destructive-active";
        case "informative":
          return "button-transparent-on-surface-information-default hover:button-transparent-on-surface-information-hover active:button-transparent-on-surface-information-active";
        case "alert":
          return "button-transparent-on-surface-alert-default hover:button-transparent-on-surface-alert-hover active:button-transparent-on-surface-alert-active";
        case "success":
          return "button-transparent-on-surface-success-default hover:button-transparent-on-surface-success-hover active:button-transparent-on-surface-success-active";
        case "brand":
        default:
          return "button-transparent-on-surface-brand-default hover:button-transparent-on-surface-brand-hover active:button-transparent-on-surface-brand-active";
      }
    }), i = l(() => {
      switch (t.linkColor) {
        case "base":
          return "button-base-on-surface-neutral-hover!";
        case "superadmin":
          return "text-superadmin!";
        case "destructive":
          return "button-transparent-on-surface-destructive-hover!";
        case "informative":
          return "button-transparent-on-surface-information-hover!";
        case "alert":
          return "button-transparent-on-surface-alert-hover!";
        case "success":
          return "button-transparent-on-surface-success-hover!";
        case "brand":
        default:
          return "button-transparent-on-surface-brand-hover!";
      }
    }), f = l(() => {
      switch (t.linkColor) {
        case "base":
          return "button-base-on-surface-neutral-active!";
        case "superadmin":
          return "text-superadmin!";
        case "destructive":
          return "button-transparent-on-surface-destructive-active!";
        case "informative":
          return "button-transparent-on-surface-information-active!";
        case "alert":
          return "button-transparent-on-surface-alert-active!";
        case "success":
          return "button-transparent-on-surface-success-active!";
        case "brand":
        default:
          return "button-transparent-on-surface-brand-active!";
      }
    }), h = l(() => {
      switch (t.linkSize) {
        case "base":
          return "button-sm text-sm leading-5";
        case "lg":
          return "button-base leading-6";
        default:
          return "button-sm text-sm leading-5";
      }
    });
    return (g, y) => (n(), a(s(e.tag), {
      class: o(["hover:underline underline-offset-4 text-left", [d(r), d(h), {
        [d(f)]: e.active,
        "underline!": e.hover,
        [d(i)]: e.hover,
        underline: e.linkUnderline || e.active,
        "opacity-80! button-base-on-surface-neutral-default!": e.disabled
      }]]),
      disabled: e.disabled,
      active: e.active
    }, {
      default: u(() => [
        c(g.$slots, "default")
      ]),
      _: 3
    }, 8, ["disabled", "active", "class"]));
  }
}, M = {
  __name: "Transparent",
  props: {
    tag: String,
    hover: Boolean,
    active: Boolean,
    disabled: Boolean
  },
  setup(e) {
    return (t, r) => (n(), a(s(e.tag), {
      class: o(["hover:button-transparent-surface-hover active:button-transparent-surface-active button-base-on-surface-neutral-default hover:button-base-on-surface-neutral-hover active:button-base-on-surface-neutral-active", {
        "button-transparent-surface-hover! button-base-on-surface-neutral-hover!": e.hover,
        "button-base-on-surface-neutral-active! button-transparent-surface-active!": e.active
      }]),
      disabled: e.disabled,
      active: e.active
    }, {
      default: u(() => [
        c(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["disabled", "active", "class"]));
  }
}, j = {
  __name: "TransparentSubtle",
  props: {
    tag: String,
    hover: Boolean,
    active: Boolean,
    disabled: Boolean
  },
  setup(e) {
    return (t, r) => (n(), a(s(e.tag), {
      class: o(["button-transparent-subtle-on-surface-default hover:button-transparent-subtle-on-surface-hover active:button-transparent-subtle-on-surface-active", {
        "button-transparent-subtle-on-surface-hover!": e.hover,
        "button-transparent-subtle-on-surface-active!": e.active
      }]),
      disabled: e.disabled,
      active: e.active
    }, {
      default: u(() => [
        c(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["disabled", "active", "class"]));
  }
}, A = {
  __name: "TransparentSubtleInvert",
  props: {
    tag: String,
    hover: Boolean,
    active: Boolean,
    disabled: Boolean
  },
  setup(e) {
    return (t, r) => (n(), a(s(e.tag), {
      class: o(["button-transparent-subtle-on-surface-invert-default hover:button-transparent-subtle-on-surface-invert-hover active:button-transparent-subtle-on-surface-invert-active", {
        "button-transparent-subtle-on-surface-invert-hover!": e.hover,
        "button-transparent-subtle-on-surface-invert-active!": e.active
      }]),
      disabled: e.disabled,
      active: e.active
    }, {
      default: u(() => [
        c(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["disabled", "active", "class"]));
  }
}, P = {
  key: 0,
  class: "w-5 h-5 relative flex items-center justify-center"
}, E = {
  key: 0,
  class: "absolute inset-0 flex items-center justify-center pointer-events-none"
}, q = {
  __name: "DButton",
  props: {
    tag: {
      type: String,
      default: "button",
      description: "HTML tag to render for the button (e.g., button, a, div)",
      editable: !1
    },
    theme: {
      type: String,
      default: "brand",
      description: "Theme style for the button. Controls color and style.",
      deprecated: ["primary", "primary-subtle", "secondary"],
      validator(e) {
        return [
          "primary",
          "brand",
          "primary-subtle",
          "brand-subtle",
          "base",
          "secondary",
          "destructive",
          "destructive-subtle",
          "text-link",
          "transparent",
          "transparent-subtle",
          "transparent-subtle-invert",
          "outline",
          "superadmin",
          "input-alias"
        ].includes(e);
      }
    },
    label: {
      type: String,
      description: "Label for screen readers to read, this is required if the button does not contain a label (only icon), the label will be the name of the icon by default"
    },
    linkColor: {
      type: String,
      default: "brand",
      description: "Color for text links. Only applies when theme is text-link.",
      validator(e) {
        return [
          "base",
          "superadmin",
          "destructive",
          "informative",
          "alert",
          "success",
          "brand"
        ].includes(e);
      }
    },
    linkUnderline: {
      type: Boolean,
      default: !0,
      description: "Show underline for text links."
    },
    linkSize: {
      type: String,
      default: "base",
      description: "Size for text links.",
      validator(e) {
        return [
          "base",
          "lg"
        ].includes(e);
      }
    },
    size: {
      type: String,
      default: "md",
      description: "Size of the button (sm, md, lg).",
      validator(e) {
        return [
          "sm",
          "md",
          "lg"
        ].includes(e);
      }
    },
    indicator: {
      type: Boolean,
      default: !1,
      description: "Display a notification indicator on the button."
    },
    indicatorNumber: {
      type: [String, Number],
      default: null,
      description: "Display a notification number in the indicator of the button."
    },
    indicatorColor: {
      type: String,
      default: "destructive",
      description: "The color for the notification indicator",
      validator(e) {
        return [
          "destructive",
          "brand",
          "accent"
        ].includes(e);
      }
    },
    indicatorBorder: {
      type: Boolean,
      default: !0,
      description: "Display a border around the indicator"
    },
    icon: {
      type: String,
      description: "Icon to display in the button.",
      iconify: !0
    },
    iconSet: {
      type: String,
      description: "Icon set for the main icon.",
      deprecated: "Use icon prop with full iconify icon string"
    },
    iconType: {
      type: String,
      description: "Icon type for the main icon.",
      deprecated: "Use icon prop with full iconify icon string"
    },
    iconSize: {
      type: String,
      default: "w-5 h-5",
      description: "Size of the main icon."
    },
    leftIcon: {
      type: String,
      description: "Icon to display on the left side of the button.",
      iconify: !0
    },
    leftIconSet: {
      type: String,
      description: "Icon set for the left icon.",
      deprecated: "Use left icon prop with full iconify icon string"
    },
    leftIconType: {
      type: String,
      description: "Icon type for the left icon.",
      deprecated: "Use left icon prop with full iconify icon string"
    },
    rightIcon: {
      type: String,
      description: "Icon to display on the right side of the button.",
      iconify: !0
    },
    rightIconSet: {
      type: String,
      description: "Icon set for the right icon.",
      deprecated: "Use right icon prop with full iconify icon string"
    },
    rightIconType: {
      type: String,
      description: "Icon type for the right icon.",
      deprecated: "Use right icon prop with full iconify icon string"
    },
    wide: {
      type: Boolean,
      description: "Make the button full width."
    },
    disabled: {
      type: Boolean,
      description: "Disable the button."
    },
    hover: {
      type: Boolean,
      description: "Manually set the button hover state."
    },
    active: {
      type: Boolean,
      description: "Manually set the button active state."
    },
    focused: {
      type: Boolean,
      description: "Manually set the button focused state."
    },
    border: {
      type: Boolean,
      description: "Add a border to the button."
    },
    activeRing: {
      type: Boolean,
      default: !0,
      description: "Show active ring when button is focused.",
      editable: !1
    },
    loading: {
      type: Boolean,
      description: "Show a loading spinner in the button."
    },
    stopPropagation: {
      type: Boolean,
      description: "Call stopPropagation() on click event.",
      editable: !1
    },
    preventDefault: {
      type: Boolean,
      description: "Call preventDefault() on click event.",
      editable: !1
    },
    tabindex: {
      type: String,
      default: "0",
      description: "Tabindex for the button.",
      editable: !1
    }
  },
  emits: {
    click: {
      description: "Emitted when the button is clicked"
    }
  },
  setup(e, { emit: t }) {
    const r = t, i = e, f = l(() => {
      if (i.theme === "text-link")
        return "";
      if (i.icon)
        switch (i.size) {
          case "sm":
            return "w-[30px] h-[30px] rounded-button-sm";
          case "lg":
            return "w-10 h-10 rounded-button-lg";
          case "md":
          default:
            return "w-[38px] h-[38px] rounded-button-lg";
        }
      switch (i.size) {
        case "sm":
          return "button-sm text-sm px-button-x-sm py-button-y-sm leading-5 rounded-button-sm";
        case "lg":
          return "button-sm text-sm px-button-x-lg py-button-y-lg leading-5 rounded-button-lg";
        case "md":
        default:
          return "button-sm text-sm px-button-x-md py-button-y-md leading-5 rounded-button-lg";
      }
    });
    let h = l(() => {
      switch (i.theme) {
        case "primary":
        case "brand":
          return C;
        case "primary-subtle":
        case "brand-subtle":
          return T;
        case "base":
        case "secondary":
          return k;
        case "destructive":
          return w;
        case "destructive-subtle":
          return z;
        case "text-link":
          return N;
        case "transparent":
          return M;
        case "transparent-subtle":
          return j;
        case "transparent-subtle-invert":
          return A;
        case "outline":
          return I;
        case "superadmin":
          return U;
        case "input-alias":
          return $;
      }
    });
    const g = l(() => {
      if (i.iconSize)
        return i.iconSize;
      switch (i.size) {
        case "sm":
        case "md":
        default:
          return "w-5 h-5";
        case "lg":
          return "w-6 h-6";
      }
    }), y = (b) => {
      i.preventDefault && b.preventDefault(), i.stopPropagation && b.stopPropagation(), !(i.disabled || i.loading) && r("click");
    };
    return (b, L) => (n(), a(s(d(h)), {
      tag: e.tag,
      "aria-label": e.icon ? e.label || e.icon : e.label,
      class: o(["relative inline-flex items-center gap-x-1.5 cursor-pointer focus-visible:z-20 focus-visible:outline-2 focus-visible:outline-offset-2 transition-colors duration-75 has-[[data-spark='DAvatar']]:px-button-y-md!", [d(f), {
        "justify-center": e.icon,
        "pointer-events-none cursor-not-allowed opacity-50": e.disabled,
        "pointer-events-none": e.loading,
        "flex-1 w-full justify-center": e.wide,
        "active:outline-none!": !e.activeRing,
        "outline-2 outline-offset-2 outline-(--border-brand-base)": e.focused
      }]]),
      disabled: e.disabled,
      tabindex: e.tabindex,
      hover: e.hover,
      active: e.active,
      focused: e.focused,
      border: e.border,
      "link-color": e.linkColor,
      "link-underline": e.linkUnderline,
      "link-size": e.linkSize,
      "d-group-border": "",
      "data-spark": "dbutton",
      "data-size": e.size,
      onClick: y
    }, {
      default: u(() => [
        B("span", {
          class: o(["inline-flex items-center gap-x-1.5 pointer-events-none **:data-[spark=DAvatar]:-my-1", [e.loading ? "opacity-0" : "opacity-100"]])
        }, [
          e.leftIcon ? (n(), a(m, {
            key: 0,
            icon: e.leftIcon,
            "icon-set": e.leftIconSet ?? e.iconSet,
            type: e.leftIconType ?? e.iconType,
            size: e.size === "sm" ? "w-4 h-4" : "w-5 h-5"
          }, null, 8, ["icon", "icon-set", "type", "size"])) : v("", !0),
          c(b.$slots, "default", {}, () => [
            e.icon ? (n(), p("div", P, [
              S(m, {
                icon: e.icon,
                "icon-set": e.iconSet,
                type: e.iconType,
                size: d(g),
                indicator: e.indicator,
                "indicator-number": e.indicatorNumber,
                "indicator-color": e.indicatorColor,
                "indicator-border": e.indicatorBorder
              }, null, 8, ["icon", "icon-set", "type", "size", "indicator", "indicator-number", "indicator-color", "indicator-border"])
            ])) : v("", !0)
          ]),
          e.rightIcon ? (n(), a(m, {
            key: 1,
            icon: e.rightIcon,
            "icon-set": e.rightIconSet ?? e.iconSet,
            type: e.rightIconType ?? e.iconType,
            size: e.size === "sm" ? "w-4 h-4" : "w-5 h-5"
          }, null, 8, ["icon", "icon-set", "type", "size"])) : v("", !0)
        ], 2),
        e.loading ? (n(), p("span", E, [
          S(x, { active: e.loading }, null, 8, ["active"])
        ])) : v("", !0)
      ]),
      _: 3
    }, 8, ["tag", "aria-label", "class", "disabled", "tabindex", "hover", "active", "focused", "border", "link-color", "link-underline", "link-size", "data-size"]));
  }
};
export {
  q as _,
  $ as a
};
